

import AddProductStepOne from "pages/Ecommerce/EcommerceProducts/AddProduct/components/AddProductStepOne";
import React, { LegacyRef, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Col, Container, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import OnboardingImage from '../../assets/images/step1.png';
import "../../assets/scss/pages/_onBoarding.scss";
import AddressTwo from "./AddressTwo/AddressFormTwo";
import BankIdInform from "./BankInformTwo/BankInformTwo";
import TellUsShop from "./TellUsShop/TellUsShop";
import { ToastContainer } from "react-toastify";
import DoneStep from "../../assets/images/check.png"
import SimpleBar from "simplebar-react";

const OnboardingTabs = [
    {
        label: "Shop Details & Verification 📝",
        value: "isStoreCreated",
        heading: "Tell Us About Your Shop",
    },
    {
        label: "Add Pickup Address 📍",
        value: "isAddressAdded",
        heading: "Where Will You Ship From?",
    },
    {
        label: "Add Bank Details 💳",
        value: "isIdBankDetails",
        heading: "Upload NIC",
    },
    // {
    //     label: "Add Products 🛍️",
    //     value: "isProductAdded",
    //     heading: "Add Product",
    // }
];

const BuypassOnBoarding = (props: any) => {
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);
    const { id } = useParams();
    const bankDetailFormikRef = useRef<{ handleSubmit: () => Promise<boolean> } | null>(null);
    const pickupAddressFormikRef = useRef<{ handleSubmit: () => Promise<boolean> } | null>(null);
    const addProductButtonRef = useRef<any>(null);
    const [loader, setLoader] = useState<boolean>(false);

    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );
    const user = useSelector(selectUser);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (user && user.storeStatus) {
            for (let i = 0; i < OnboardingTabs.length; i++) {
                if (OnboardingTabs[i]) {
                    let key = OnboardingTabs[i].value;
                    if (user.storeStatus[key]) {
                        if (i === 0) {
                            continue;
                        } else if (i === 2) {
                            if (location.pathname === "/on-boarding") {
                                navigate("/manage-products");
                            }
                        } else {
                            setActiveTabIndex(i + 1);
                        }
                    }
                    else{
                        break;
                    }
                }
            }
        }
    }, [user]);

    const onProductFormLoaderChange = (value:boolean)=>{
            setLoader(value);
            console.log(value,"loader value check")
    }


    const handleNextTab = async () => {
        let formikRef;
        try {
            setLoader(true);
            
            if (activeTabIndex === 1) {
                formikRef = pickupAddressFormikRef;
            } else if (activeTabIndex === 2) {
                formikRef = bankDetailFormikRef;
            } else if (activeTabIndex === 3) {
                
                formikRef = addProductButtonRef;
            }
            let isFormValid = true; 
            if (formikRef && formikRef.current) {
                if(activeTabIndex===3){
                    isFormValid = await formikRef.current.clickButton();

                }
                else{

                    isFormValid = await formikRef.current.handleSubmit();
                }
            }
            if (isFormValid) {
                setActiveTabIndex(activeTabIndex + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (error) {
            console.error("Error in handleNextTab:", error);
            setLoader(false);

        } finally {
            setLoader(false);
        }
    };

    const handlePrevTab = () => {
        setActiveTabIndex(activeTabIndex - 1);
    };

    const renderOnboardingForm = () => {
        if (activeTabIndex === 0) {
            return <TellUsShop />;
        }
        if (activeTabIndex === 1) {
            return <AddressTwo setFormikAddressRef={(instance: any) => (pickupAddressFormikRef.current = instance)} />;
        }
    }

    const renderOnboardingBody = () => {
        if (activeTabIndex === 2) {
            return <BankIdInform setFormikRef={(instance: any) => (bankDetailFormikRef.current = instance)} />;
        }
        if (activeTabIndex === 3) {
            return <AddProductStepOne ref={addProductButtonRef} key={id} productId={id ?? '' } onButtonRes={(val) => onProductFormLoaderChange(val)} />;
        }
        

        return (
            <Card className="cardSett">
                <CardHeader>
                    <h4 className="card-title-ob mb-0">{OnboardingTabs[activeTabIndex].heading}</h4>
                </CardHeader>
                <CardBody className="mb-3">
                    <div className="row d-flex align-items-center">
                        <div className="col-md-6 d-flex justify-content-center">
                            {renderOnboardingForm()}
                        </div>
                        <div className="col-md-6 my-3 mobile-hide">
                            <img
                                src={OnboardingImage}
                                alt="Address Form Image"
                                className="image_main"
                            />
                        </div>
                    </div>

                </CardBody>
            </Card>
        )

    }

    return (
        <React.Fragment>
            <ToastContainer closeButton={false} limit={1}/>
            <div className="onBoardingMain extra-pedd">
                <Container style={{ maxWidth: '1240px' }}>
                    <div className={`sticky-bar ${isScrolled ? 'scrolled' : ''}`}>
                        <CardHeader className="justify-content-center align-items-center d-flex mb-2">
                            <div className="row w-100">
                                <div className="col-md-5 d-flex align-items-center p-0">
                                    <h4 className="card-title mb-0 flex-grow-1 head">Let’s Get Your Shop Live! 🚀</h4>
                                </div>

                                <div className="steps col-md-4 d-flex align-items-center justify-content-end">
                                    <p className="step-text mb-0">
                                        3 Steps <span className="highlight">to Turn Your Digital Shop Live</span>
                                    </p>
                                </div>

                                <div className="col-md-3 d-flex justify-content-end align-items-center my-2 p-0 dashView">
                                    <Button
                                        onClick={handlePrevTab}
                                        className="button-prev me-2"
                                        disabled={activeTabIndex === 0}
                                        data-testing-id="previousButton_IndexTwo"
                                      >
                                        <i className="bx bxs-chevron-left icon"></i>
                                    </Button>
                                    {activeTabIndex !== (OnboardingTabs.length - 1) ? (
                                        <Button
                                            disabled={loader}
                                            className="btnSubmit"
                                            // onClick={handleNextTab}
                                            onClick={() => {
                                                if (activeTabIndex === 1) {
                                                  localStorage.removeItem("step2");
                                                }
                                                handleNextTab();
                                              }}
                                            data-testing-id="continueButton_IndexTwo"
                                        >
                                            {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                            Continue
                                        </Button>
                                    ) : (
                                        <Button
                                            disabled={loader }
                                            className="btnSubmit"
                                            // onClick={handleNextTab}
                                            onClick={() => {
                                                if (activeTabIndex === 2) {
                                                  localStorage.removeItem("step3");
                                                }
                                                handleNextTab();
                                              }}
                                            data-testing-id="submitButton_IndexTwo"
                                        >
                                            {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}

                                            Submit
                                        </Button>
                                    )}
                                </div>
                            </div>
                            
                        </CardHeader>

                        <Card className="cardSett">
                            <CardBody>
                                <div className="d-flex justify-content-between align-items-center w-100 mobileTapBrres px-3 py-2 ">
                                    {OnboardingTabs.map((tab, index) => {
                                        const isCompleted = user?.storeStatus?.[tab.value] || false;

                                        return (
                                            <>
                                                <div
                                                    key={tab.value}
                                                    className="d-flex align-items-center position-relative tabSteps onBoardindBox"
                                                    // onClick={() => {
                                                    //     if (index <= activeTabIndex) {
                                                    //         setActiveTabIndex(index);
                                                    //     }
                                                    // }}
                                                    // style={{ cursor: index <= activeTabIndex ? "pointer" : "not-allowed" }} 
                                                >
                                                    {/* Tab Circle */}
                                                    <div
                                                        className={`tab-circle ${(activeTabIndex === index || isCompleted) ? 'active' : 'inactive'}`}
                                                    >
                                                        {isCompleted ? (
                                                            <img src={DoneStep} alt="Step Completed" className="done-step-icon" />
                                                        ) : (
                                                            index + 1
                                                        )}
                                                    </div>

                                                    {/* Tab Label */}
                                                    <span
                                                        className={`tab-text mobileResTab ${(activeTabIndex === index || isCompleted) ? 'active' : 'inactive'}`}
                                                    >
                                                        {tab.label}
                                                    </span>

                                                    {/* Progress Line */}
                                                    {index !== (OnboardingTabs.length - 1) && (
                                                        <div
                                                            className={` progress-line ${(activeTabIndex > index || isCompleted) ? 'active' : ''}`}
                                                        />
                                                    )}
                                                </div>


                                            </>
                                        );
                                    })}
                                </div>
                                <div className="PageNmaeRes text-center mt-3">
                                    {activeTabIndex === 0 && <h5 className="p-0 m-0 fw-bold">Shop Details & Verification 📝</h5>
                                    }

                                    {activeTabIndex === 1 && <h5 className="p-0 m-0 fw-bold">Add Pickup Address 📍</h5>
                                    }

                                    {activeTabIndex === 2 && <h5 className="p-0 m-0 fw-bold">Add Bank Details 💳</h5>
                                    }

                                    {activeTabIndex === 3 && <h5 className="p-0 m-0 fw-bold">Add Products 🛍️ </h5>
                                    }

                                </div>
                            </CardBody>
                        </Card>
                    </div>


                    <Row className="resMobileDv">
                        <Col lg={12}>
                            {renderOnboardingBody()}
                        </Col>
                    </Row>

                </Container>
            </div>
                <div className="mobileResContinueButton ">
                    <div className="d-flex justify-content-center gap-3 align-items-center">

                        <div className="" style={{ width: "40%" }}>
                                <Button 
                           onClick={handlePrevTab}
                                    className="btn btn-light textdark w-100"
                           disabled={activeTabIndex === 0}
                             data-testing-id="previousButton_IndexTwo"
                             
                             
                              >
                               Back
                             </Button>
                            </div> 
                            <div className="w-40"  style={{ width: "40%" }}>
                                
         {activeTabIndex !== OnboardingTabs.length - 1 ? (
        <Button
          disabled={loader}
          className="btnSubmit w-100"
          onClick={() => {
            if (activeTabIndex === 1) {
              localStorage.removeItem("step2");
            }
            handleNextTab();
          }}
          data-testing-id="continueButton_IndexTwo"
        >
          {loader && <Spinner size="sm" className="me-2">Loading...</Spinner>}
          Continue
        </Button>
      ) : (
        <Button
          disabled={loader}
          className="btnSubmit w-100"
          onClick={() => {
            if (activeTabIndex === 2) {
              localStorage.removeItem("step3");
            }
            handleNextTab();
          }}
          data-testing-id="submitButton_IndexTwo"
        >
          {loader && <Spinner size="sm" className="me-2">Loading...</Spinner>}
          Submit
        </Button>
      )}</div>  
                            </div>
                {/* <div className="col-md-3 d-flex justify-content-end align-items-center ">
                    <Button
                        onClick={handlePrevTab}
                        className="button-prev me-2"
                        disabled={activeTabIndex === 0}
                        data-testing-id="previousButton_IndexTwo"
                    >
                        <i className="bx bxs-chevron-left icon"></i>
                    </Button>
                    {activeTabIndex !== (OnboardingTabs.length - 1) ? (
                        <Button
                            disabled={loader}
                            className="btnSubmit"
                            onClick={handleNextTab}
                            data-testing-id="continueButton_IndexTwo"
                        >
                            {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                            Continue
                        </Button>
                    ) : (
                        <Button
                            disabled={loader }
                            className="btnSubmit"
                            onClick={handleNextTab}
                            data-testing-id="submitButton_IndexTwo"
                        >
                            {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}

                            Submit
                        </Button>
                    )}
                </div> */}
                </div>
        </React.Fragment>

    );
};

export default BuypassOnBoarding;
